import React, { useState } from 'react';
import Icon from 'components/ui/icon';

const DesktopApplication = () => {
  const [online, toggleOnline] = useState(true);
  const updateOnlineStatus = () => {
    /*isOnline().then((online) => {
      toggleOnline(online);
    });*/
    toggleOnline(true);
  };

  if (!online) {
    return (
      <div className="banner offline">
        <Icon icon="warning" className="mr-10" />
        {t('general.no_internet_alert')}
      </div>
    );
  }
  return null;
};

export default DesktopApplication;
